import { render, staticRenderFns } from "./recipients-import-table.vue?vue&type=template&id=409f04b8&"
import script from "./recipients-import-table.vue?vue&type=script&lang=js&"
export * from "./recipients-import-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports